import React from 'react';
import styles from './KeyboardSlot.module.scss';

export const KEYBOARD_SLOT_ID = 'keyboard_slot';

export default function KeyboardSlot() {
  return <div className={styles.container} id={KEYBOARD_SLOT_ID} />;
}
